import { z } from 'zod';

import {
    businessEmailSchema,
    businessPhoneSchema,
    practiceNameSchema,
    taxIdSchema,
} from '@nesso/practice-contracts/practice.models';

export {
    practiceAddLocation,
    practiceUpdateLocation,
} from '@nesso/practice-contracts/practice.commands';
export {
    APPOINTMENT_MODALITIES,
    appointmentModalitySchema,
    businessEmailSchema,
    businessPhoneSchema,
    PLACE_OF_SERVICE_CODES,
    PLACE_OF_SERVICE_LABELS,
    placeOfServiceCodeSchema,
    practiceLocationDetailsSchema,
    practiceNameSchema,
    taxIdSchema,
    US_STATE_NAMES,
    US_STATES,
} from '@nesso/practice-contracts/practice.models';
export {
    practiceDetailsSchema,
    practiceLocationSchema,
} from '@nesso/practice-contracts/practice.queries';

// Composed from the per-field schemas rather than `.omit()`-ing `practiceUpdate`'s input: zod v4
// refuses `.omit()` on a schema carrying a `.refine()`. `practiceId` is set server-side, never sent.
export const updatePracticeInputSchema = z.object({
    name: practiceNameSchema.optional(),
    businessEmail: businessEmailSchema.optional(),
    // Nullable, not just optional — sending `null` is how the field is cleared.
    businessPhone: businessPhoneSchema.nullable().optional(),
    taxId: taxIdSchema.optional(),
});
